import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupSelectFamily() {
  
    const navigate = useNavigate();
    const location = useLocation();
   
    const {
        data: familyCaptions = [],
        isLoading: captionLoading,
        isError: captionError,
      } = useQuery({
        queryKey: ['selectFamilyCaptions'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-select-family-caption-api`).then((res) => {
            if (res.data.Status === "Success") return res.data.captions;
            else throw new Error("Caption fetch failed");
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });

      const relatedFamilies = location.state?.relatedFamilies || [];

      const handleRequestSubmit = async (code) => {
        try {
          const res = await axios.post(
            `${API_URL}/reg-signup-family-request-api`,
            { family_code: code },
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            navigate(res.data.redirect);
          } else {
            toast.error("Failed to request Family.");
          }
        } catch (error) {
          console.error("Request failed:", error);
          toast.error("Something went wrong.");
        }
      };
   
    

    return (
        <div className=" text-whitex ">
        <div id="page">
        <ToastContainer />
        <div className="page-content pb-0">
                
                <div className="row" style={{marginTop: '2%'}}>
                    <div className="col-3 col-md-3">
                    </div>
                  <div className="col-6 col-md-6 deleteacc-detail"> 
                   <center>
                <label style={{fontWeight: '900'}}>Family you may know</label>
                </center>  
                 </div>  
                </div>


                <p >
                    <center>

                {captionLoading ? 'Loading caption...' : (
                familyCaptions.map((caption, index) => (
                <span key={index}>{caption.caption}</span>
                ))
                )}
                </center>
                </p>

                <div style={{overflowY: 'scroll', height: '500px', marginBottom: '10%'}}>

                {relatedFamilies.map((family, index) => (
                <div key={index} className="card mb-2 p-2">
                    <h5>{family.name}</h5>
                    
                    {family.admin && family.admin.length > 0 && (
                    <p>
                      <li>
                      {family.admin
                        .map(a => `${a.n_prefix || ''} ${a.name} ${a.last_name}`)
                        .join(", ")}
                      </li>
                    </p>
                    )}
                    <div className='row'>
                      <div className='col-md-12'>
                      <center>
                        <button onClick={() => handleRequestSubmit(family.family_code)} className='btn btn-primary'>Request to join</button>
                      </center>
                      </div>
                    </div>
                </div>
                ))}

                </div>

        

                <div class="card-bottom card_bottom">
                
                    <div className='row'>


                        <div className='col-3 col-md-3'>
                        <Link onClick={() => navigate(-1)} class="btn btn-primary">
                                                        &emsp;<i class="fa fa-arrow-left btn_arrow"></i>&emsp;</Link>
                        </div>
                        <div className='col-4 col-md-4'>

                        </div>

                        <div className='col-5 col-md-5'>
                        <Link to='/sign-up-family' className="btn btn-primary" type="submit">
                        Didn't find family</Link>
                        </div>
                    </div>
                    
                </div>
                

            
        </div>
    </div>
    </div>
    );
}

export default SignupSelectFamily;
